import { Routes } from '@angular/router';
//import { } from './'
import { AuthGuard } from './shared/_guards/auth.guard';
import { HomeComponent } from './modules/home/home.component';
import { LoginComponent } from './modules/login/login.component';
import { JoinAppComponent } from './modules/login/join-app/join-app.component';
import { LostPasswordComponent } from './modules/login/lost-password/lost-password.component';
import { FirstTimeComponent } from './modules/login/first-time/first-time.component';
import { ChangePasswordComponent } from './modules/login/change-password/change-password.component';
import { AdminUsersComponent, AdminUserResolve } from './modules/admin-users/admin-users.component';
import { DetailUserComponent } from './modules/admin-users/detail-user/detail-user.component';
import { CounterComponent } from './modules/counter/counter.component';
import { ManageFileComponent } from './modules/manage-file/manage-file.component';
import { FillAgentsComponent } from './modules/manage-file/fill-agents/fill-agents.component';
import { FillBranchComponent } from './modules/manage-file/fill-branch/fill-branch.component';
import { FillOfficesComponent } from './modules/manage-file/fill-offices/fill-offices.component';
import { FillCitiesComponent } from './modules/manage-file/fill-cities/fill-cities.component';
import { DownloadFeedbackComponent } from './modules/manage-file/download-feedback/download-feedback.component';
import { PortfolioComponent } from './modules/portfolio/portfolio.component';
import { DetailPortfolioComponent } from './modules/portfolio/detail-portfolio/detail-portfolio.component';
import { GenerateLetterComponent } from './modules/generate-letter/generate-letter.component';
import { ManagementComponent } from './modules/management/management.component';
import { AdminTablesComponent } from './modules/admin-tables/admin-tables.component';
import { TableAgentsComponent } from './modules/admin-tables/table-agents/table-agents.component';
import { TableBranchesComponent } from './modules/admin-tables/table-branches/table-branches.component';
import { TableOfficesComponent } from './modules/admin-tables/table-offices/table-offices.component';
import { TableCitiesComponent } from './modules/admin-tables/table-cities/table-cities.component';
import { TableCompanyComponent } from './modules/admin-tables/table-company/table-company.component';
import { PaymentsCancellationsComponent } from './modules/payments-cancellations/payments-cancellations.component';
import { DevolutionsComponent } from './modules/devolutions/devolutions.component';
import { SearchComponent } from './modules/search/search.component'
import { ReportsComponent } from './modules/reports/reports.component'

export const appRoutes: Routes = [
  {
    path: 'pruebas',
    component: AdminTablesComponent,
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    //data: { roles: [1,2] } //Admin
  },
  {
    path: 'admin-users',
    component: AdminUsersComponent,
    canActivate: [AuthGuard],
    data: { roles: [1] },   
    resolve: { adminUserData : AdminUserResolve }
  },
  {
    path: 'admin-users/detail/:id/:isEditable',
    component: DetailUserComponent,
    canActivate: [AuthGuard],
    data: { roles: [1] },
  },
  {
    path: 'admin-tables',
    component: AdminTablesComponent,
    canActivate: [AuthGuard],
    data: { roles: [1] },
    children: [
      {
        path: 'agents',
        component: TableAgentsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'branches',
        component: TableBranchesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'offices',
        component: TableOfficesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'cities',
        component: TableCitiesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'company',
        component: TableCompanyComponent,
        canActivate: [AuthGuard]
      }
    ] 
  },
  {
    path: 'portfolio',
    component: PortfolioComponent,
    canActivate: [AuthGuard],
    data: { roles: [4] }
  },
  {
    path: 'portfolio/detail/:id',
    component: DetailPortfolioComponent,
    canActivate: [AuthGuard],
    data: { roles: [1,2,3,4] }
  },
  {
    path: 'portfolio/detail/:id/:idPolicy',
    component: DetailPortfolioComponent,
    canActivate: [AuthGuard],
    data: { roles: [1,2,3,4] }
  },
  {
    path: 'manage-file',
    component: ManageFileComponent,  
    canActivate: [AuthGuard],
    data: { roles: [1, 2,3] },
    children: [
      {
        path: 'fill-agents',
        component: FillAgentsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'fill-branches',
        component: FillBranchComponent,
        canActivate: [AuthGuard],
        resolve: FillBranchComponent
      },
      {
        path: 'fill-offices',
        component: FillOfficesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'fill-cities',
        component: FillCitiesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'download-feedback',
        component: DownloadFeedbackComponent,
        canActivate: [AuthGuard]
      }
    ] 
  },
  {
    path: 'generate-letter',
    component: GenerateLetterComponent,
    canActivate: [AuthGuard],
    data: { roles: [1,2,3,4] }   
  },
  {
    path: 'management',
    component: ManagementComponent,
    canActivate: [AuthGuard],
    data: { roles: [1, 2,3] }   
  },
  {
    path: 'payments-cancellations',
    component: PaymentsCancellationsComponent,
    canActivate: [AuthGuard],
    data: { roles: [1, 2, 3] }   
  },
  {
    path: 'devolutions',
    component: DevolutionsComponent,
    canActivate: [AuthGuard],
    data: { roles: [1, 2, 3] }   
  },
  {
    path: 'search',
    component: SearchComponent,
    canActivate: [AuthGuard],
    data: { roles: [1, 2, 3,4] }   
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
    children: [
      {
        path: '',
        component: JoinAppComponent
      },
      {
        path: 'lost-password',
        component: LostPasswordComponent
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'first-time',
        component: FirstTimeComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  { path: '**', redirectTo: '' }
 
];
